import { render, staticRenderFns } from "./ProducerDashboard.vue?vue&type=template&id=11e8f235"
import script from "./ProducerDashboard.vue?vue&type=script&lang=js"
export * from "./ProducerDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProducerDashboard.vue?vue&type=style&index=0&id=11e8f235&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports